// Authentication & Role Management — Firestore-backed
import { isFirebaseReady } from './firebase.js';
import { getProfile } from './liff.js';
import { saveUser, getUser, getAdminUsersDB } from './services/db.js';

let currentUser = null;

export async function loginUser(isPinMode = false) {
    if (isPinMode) {
        if (localStorage.getItem('app_pin_auth') === 'true') {
            currentUser = {
                id: 'admin_pin_user',
                name: 'Admin (PIN)',
                role: 'admin',
                pictureUrl: 'https://ui-avatars.com/api/?name=A&background=e94d9e&color=fff&size=150',
                createdAt: new Date().toISOString()
            };
        } else {
            currentUser = null;
        }
        return currentUser;
    }

    const profile = getProfile();
    if (!profile) return null;

    if (isFirebaseReady()) {
        // Check if user exists in Firestore
        const existing = await getUser(profile.userId);
        if (existing) {
            currentUser = existing;
            
            // Only save back if name or picture actually changed (skip unnecessary Firestore write)
            const nameChanged = profile.displayName !== existing.name;
            const picChanged = profile.pictureUrl && profile.pictureUrl !== existing.pictureUrl;
            
            if (nameChanged || picChanged) {
                currentUser.name = profile.displayName;
                currentUser.pictureUrl = profile.pictureUrl || currentUser.pictureUrl;
                // Fire-and-forget — don't await, let it save in background
                saveUser(currentUser).catch(e => console.warn('Background save error:', e));
            }
        } else {
            // First-time login — create user as customer
            currentUser = {
                id: profile.userId,
                name: profile.displayName,
                role: 'customer',
                pictureUrl: profile.pictureUrl || '',
                phone: '',
                createdAt: new Date().toISOString()
            };
            await saveUser(currentUser);
        }
    } else {
        // Demo mode fallback
        currentUser = {
            id: profile.userId,
            name: profile.displayName,
            role: 'customer',
            pictureUrl: profile.pictureUrl || '',
            phone: '',
            createdAt: new Date().toISOString()
        };
    }

    console.log('👤 User logged in:', currentUser.name, `(${currentUser.role})`);
    return currentUser;
}

export function updateUserCache(user) {
    if (currentUser && currentUser.id === user.id) {
        Object.assign(currentUser, user);
    }
}

export function getCurrentUser() {
    return currentUser;
}

export function setCurrentUser(user) {
    currentUser = user;
}

export function isAdmin() {
    return currentUser && (currentUser.role === 'fortune_teller' || currentUser.role === 'admin');
}

export function isCustomer() {
    return currentUser && currentUser.role === 'customer';
}

// Auth guard — returns true if allowed
export async function requireAdmin() {
    if (!isAdmin()) {
        // First-time setup: if NO admins exist in Firestore, allow access
        if (isFirebaseReady()) {
            const admins = await getAdminUsersDB();
            if (admins.length === 0) {
                console.log('⚡ First-time setup mode — no admins found, allowing access');
                return true;
            }
        }

        const app = document.getElementById('app');
        app.innerHTML = `
      <div style="display:flex; align-items:center; justify-content:center; min-height:100dvh; padding:2rem; text-align:center;">
        <div>
          <div style="font-size:4rem; margin-bottom:1rem;">🔒</div>
          <h2 style="color:#f87171; margin-bottom:0.5rem;">ไม่มีสิทธิ์เข้าถึง</h2>
          <p style="color:#a89cc8; font-size:0.875rem; margin-bottom:1.5rem;">
            หน้านี้เฉพาะหมอดู/แอดมินเท่านั้น<br/>
            กรุณาติดต่อแอดมินเพื่อขอสิทธิ์
          </p>
          <button onclick="location.hash='#/home'" 
                  style="padding:0.75rem 1.5rem; background:linear-gradient(135deg,#9b59f0,#e94d9e); color:white; border:none; border-radius:12px; cursor:pointer; font-family:inherit; font-size:1rem;">
            🏠 กลับหน้าหลัก
          </button>
        </div>
      </div>
    `;
        return false;
    }
    return true;
}
